/**
 * 案件詳細画面内事前与信タブ申込情報ダイアログ用Form定義ファイル
 * 概要
 *  案件詳細画面内事前与信タブ申込情報ダイアログ用のForm定義をまとめたファイル
 * 更新履歴
 *  2022/09/01 新規 佐藤
 */
import { FieldChildrenProp } from '@/services/hexabase/types';

/* eslint-disable @typescript-eslint/camelcase */

export const EntryItemForm = [
  {
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'leasing_company',
    name: 'leasing_company',
    display_id: 'leasing_company',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: 'リース会社名',
      labelText: 'リース会社名',
      name: 'leasing_company',
      isReadonly: true,
      isDisabled: false,
      rules: '',
      value: ''
    },
    sizeX: 2,
    sizeY: 1,
    col: 0,
    row: 1,
    show: true
  },
  {
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'product_classification',
    name: 'product_classification',
    display_id: 'product_classification',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '商品区分',
      labelText: '商品区分',
      name: 'product_classification',
      isReadonly: true,
      isDisabled: false,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 2,
    show: true
  },
  {
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'credit_product_id',
    name: 'credit_product_id',
    display_id: 'credit_product_id',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '商品名',
      labelText: '商品名',
      name: 'credit_product_id',
      isReadonly: true,
      isDisabled: false,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 2,
    show: true
  },
  {
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'quantity',
    name: 'quantity',
    display_id: 'quantity',
    dataType: 'number',
    component: 'InputArea',
    props: {
      inputType: 'number',
      labelClass: 'mb-2',
      labelName: '数量',
      labelText: '数量',
      name: 'quantity',
      isReadonly: false,
      isDisabled: false,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 3,
    show: true
  },
  {
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'monthly_lease_fee',
    name: 'monthly_lease_fee',
    display_id: 'monthly_lease_fee',
    dataType: 'number',
    component: 'InputArea',
    props: {
      inputType: 'number',
      labelClass: 'mb-2',
      labelName: '月額リース金額',
      labelText: '月額リース金額',
      name: 'monthly_lease_fee',
      isReadonly: false,
      isDisabled: false,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 4,
    show: true
  },
  {
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'contract_month',
    name: 'contract_month',
    display_id: 'contract_month',
    dataType: 'number',
    component: 'InputArea',
    props: {
      inputType: 'number',
      labelClass: 'mb-2',
      labelName: '期間(月数)',
      labelText: '期間(月数)',
      name: 'contract_month',
      isReadonly: false,
      isDisabled: false,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 4,
    show: true
  },
  {
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'remaining_lease_fee',
    name: 'remaining_lease_fee',
    display_id: 'remaining_lease_fee',
    dataType: 'number',
    component: 'InputArea',
    props: {
      inputType: 'number',
      labelClass: 'mb-2',
      labelName: '残リース金額',
      labelText: '残リース金額',
      name: 'remaining_lease_fee',
      isReadonly: false,
      isDisabled: false,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 5,
    show: true
  },
  {
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'acceptance_plan_date',
    name: 'acceptance_plan_date',
    dataType: 'datetime',
    display_id: 'acceptance_plan_date',
    component: 'DatePickerArea',
    props: {
      labelClass: 'mb-2',
      format: 'yyyy/MM/dd',
      labelName: '納品予定日',
      labelText: '納品予定日',
      name: 'acceptance_plan_date',
      isDisabled: false,
      isClearable: true,
      rules: '',
      value: null,
      minDate: '1900/01/01',
      maxDate: '2100/12/31',
      placeholder: 'YYYY/MM/DD'
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 5,
    show: true
  },
  {
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'comment',
    name: 'comment',
    display_id: 'comment',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: 'コメント',
      labelText: 'コメント',
      name: 'comment',
      isReadonly: false,
      isDisabled: false,
      rules: '',
      value: ''
    },
    sizeX: 2,
    sizeY: 1,
    col: 0,
    row: 6,
    show: true
  }
];
export const entryItemForms = EntryItemForm;

export const ReadonlyItemForm = [
  {
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'leasing_company',
    name: 'leasing_company',
    display_id: 'leasing_company',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: 'リース会社名',
      labelText: 'リース会社名',
      name: 'leasing_company',
      isReadonly: true,
      isDisabled: false,
      rules: '',
      value: ''
    },
    sizeX: 2,
    sizeY: 1,
    col: 0,
    row: 1,
    show: true
  },
  {
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'product_classification',
    name: 'product_classification',
    display_id: 'product_classification',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '商品区分',
      labelText: '商品区分',
      name: 'product_classification',
      isReadonly: true,
      isDisabled: false,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 2,
    show: true
  },
  {
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'credit_product_id',
    name: 'credit_product_id',
    display_id: 'credit_product_id',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: '商品名',
      labelText: '商品名',
      name: 'credit_product_id',
      isReadonly: true,
      isDisabled: false,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 2,
    show: true
  },
  {
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'quantity',
    name: 'quantity',
    display_id: 'quantity',
    dataType: 'number',
    component: 'InputArea',
    props: {
      inputType: 'number',
      labelClass: 'mb-2',
      labelName: '数量',
      labelText: '数量',
      name: 'quantity',
      isReadonly: true,
      isDisabled: false,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 3,
    show: true
  },
  {
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'monthly_lease_fee',
    name: 'monthly_lease_fee',
    display_id: 'monthly_lease_fee',
    dataType: 'number',
    component: 'InputArea',
    props: {
      inputType: 'number',
      labelClass: 'mb-2',
      labelName: '月額リース金額',
      labelText: '月額リース金額',
      name: 'monthly_lease_fee',
      isReadonly: true,
      isDisabled: false,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 4,
    show: true
  },
  {
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'contract_month',
    name: 'contract_month',
    display_id: 'contract_month',
    dataType: 'number',
    component: 'InputArea',
    props: {
      inputType: 'number',
      labelClass: 'mb-2',
      labelName: '期間(月数)',
      labelText: '期間(月数)',
      name: 'contract_month',
      isReadonly: true,
      isDisabled: false,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 4,
    show: true
  },
  {
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'remaining_lease_fee',
    name: 'remaining_lease_fee',
    display_id: 'remaining_lease_fee',
    dataType: 'number',
    component: 'InputArea',
    props: {
      inputType: 'number',
      labelClass: 'mb-2',
      labelName: '残リース金額',
      labelText: '残リース金額',
      name: 'remaining_lease_fee',
      isReadonly: true,
      isDisabled: false,
      rules: '',
      value: ''
    },
    sizeX: 1,
    sizeY: 1,
    col: 0,
    row: 5,
    show: true
  },
  {
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'acceptance_plan_date',
    name: 'acceptance_plan_date',
    dataType: 'datetime',
    display_id: 'acceptance_plan_date',
    component: 'DatePickerArea',
    props: {
      labelClass: 'mb-2',
      format: 'yyyy/MM/dd',
      labelName: '納品予定日',
      labelText: '納品予定日',
      name: 'acceptance_plan_date',
      isDisabled: true,
      value: null
    },
    sizeX: 1,
    sizeY: 1,
    col: 1,
    row: 5,
    show: true
  },
  {
    search: false,
    show_list: false,
    as_title: false,
    status: false,
    fieldIndex: 1,
    title_order: 1,
    full_text: false,
    unique: false,
    min_value: '',
    max_value: '',
    // ****** //
    field_id: 'comment',
    name: 'comment',
    display_id: 'comment',
    dataType: 'text',
    component: 'InputArea',
    props: {
      labelClass: 'mb-2',
      labelName: 'コメント',
      labelText: 'コメント',
      name: 'comment',
      isReadonly: true,
      isDisabled: false,
      rules: '',
      value: ''
    },
    sizeX: 2,
    sizeY: 1,
    col: 0,
    row: 6,
    show: true
  }
];
export const readonlyItemForms = ReadonlyItemForm;
